import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { Input } from '../../ui/inputs/Input'
import { TextArea } from '../../ui/inputs/TextArea'
import { createStore, stores, view } from '../../../stores'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { Select } from '../../ui/inputs/Select'
import { SelectNumberGroup } from '../../ui/inputs/SelectNumberGroup'
import { validateReferences } from '../../../utilities/validators'
import { NavigationButtons } from '../../ui/buttons/NavigationButtons'
import { validation } from '../validation'
import { pushGtmTrigger } from '../../../utilities/window'

class NeedsStepComponent extends Component {
  constructor () {
    super()
    const store = createStore({
      pristine: true,
      isValid: false,
      errors: [],
      clear () {
        store.pristine = true
        store.isValid = true
        store.errors = []
      }
    })
    this.store = store
  }

  componentDidMount () {
    // wait for 2 seconds to ensure loading of gtag config
    (new Promise(resolve => setTimeout(resolve, 2000))).then(() => {
      pushGtmTrigger('describe_needs')
    })
  }

  checkDurationValidity () {
    const { duration } = stores.inquiry
    const isHourFilled = duration.hours >= 0
    const isMinFilled = duration.minutes >= 0
    const isHourZero = duration.hours === '0'
    const isMinuteZero = duration.minutes === '0'
    return duration && (isHourFilled && isMinFilled && (!isHourZero || !isMinuteZero))
  }

  handleSubmit () {
    const { next, t } = this.props
    let { isValid, errors } = validateReferences(this.refs)

    if (stores.inquiry.type === InquiryTypes.REALISATION) {
      isValid = this.checkDurationValidity()
      errors.push(t('common:fields:visits_duration'))
    }

    this.store.errors = errors
    this.store.isValid = isValid
    this.store.pristine = false

    if (isValid) {
      next()
      // TODO(): Update connected account !
    }
  }

  render () {
    const { t } = this.props
    const { errors } = this.store
    const { type, frequency, withVisit } = stores.inquiry
    return (
      <div className='demande__container'>
        <h3 className='demande-form__h3'>{t('common:create:speak_about_need')}</h3>
        <div className='demande-form__container'>
          <Input
            bold
            label={t('common:fields:surface')}
            name='gardenSurface'
            ref='gardenSurface'
            rules={validation.surface}
            value={stores.inquiry.gardenSurface}
            onChange={(value) => {
              stores.inquiry.gardenSurface = value
              this.store.clear()
            }}
            type='text' />
          <TextArea
            bold
            cols={30}
            label={t('common:fields:description_visit')}
            name='description'
            placeholder='Je voudrais...'
            ref='description'
            onChange={(value) => {
              stores.inquiry.description = value
              this.store.clear()
            }}
            value={stores.inquiry.description}
            required
            rows={10} />
        </div>
        <h3 className='demande-form__h3'>{t('common:create:you_want')}</h3>
        <div className={'radio ' + (frequency === InquiryFrequencies.PONCTUAL ? 'active' : '')} onClick={() => stores.inquiry.setFrequency({ frequency: InquiryFrequencies.PONCTUAL })}>
          <label className='radio__label'>
            <input className='radio__input' type='radio' value={InquiryFrequencies.PONCTUAL} checked={frequency === InquiryFrequencies.PONCTUAL} readOnly />
            <p className='radio__maintext'>{t('common:create:radio_ponctual')}</p>
          </label>
        </div>
        <div className={'radio ' + (frequency === InquiryFrequencies.MAINTENANCE ? 'active' : '')} onClick={() => stores.inquiry.setFrequency({ frequency: InquiryFrequencies.MAINTENANCE })}>
          <label className='radio__label'>
            <input className='radio__input' type='radio' value={InquiryFrequencies.MAINTENANCE} checked={frequency === InquiryFrequencies.MAINTENANCE} readOnly />
            <p className='radio__maintext'>{t('common:create:radio_maintenance')}</p>
            <p className='radio__text'>{t('common:create:radio_maintenance_text')} </p>
          </label>
        </div>
        {/**
          * Block - visit is mandatory for frequency maintenance
          */}
        {
          withVisit
          ? <h3 className='demande-form__h3'>{t(`common:create:maintenance_visits_title`)}</h3>
          : ''
        }
        {/**
          * Block - selecting if visit is needed
          */}
        {
          !withVisit
          ? (
            <div>
              <h3 className='demande-form__h3'>{t('common:create:ponctual_visits_title')}</h3>
              <div className={'radio ' + (type === InquiryTypes.VISIT ? 'active' : '')} onClick={() => stores.inquiry.setType({ type: InquiryTypes.VISIT })}>
                <label className='radio__label'>
                  <input className='radio__input' type='radio' value='visite'
                    checked={type === InquiryTypes.VISIT} readOnly />
                  <p className='radio__maintext'>{t('common:create:radio_visits_on')}</p>
                  <p className='radio__text'>{t('common:create:radio_visits_on_text')}</p>
                </label>
              </div>
              <div className={'radio ' + (type === InquiryTypes.REALISATION ? 'active' : '')} onClick={() => stores.inquiry.setType({ type: InquiryTypes.REALISATION })}>
                <label className='radio__label'>
                  <input className='radio__input' type='radio' value='realisation'
                    checked={type === InquiryTypes.REALISATION} readOnly />
                  <p className='radio__maintext'>{t('common:create:radio_visits_off')}</p>
                  <p className='radio__text'>{t('common:create:radio_visits_off_text')}</p>
                </label>
              </div>
            </div>
          ) : ''
        }
        {/**
          * Block - duration selection
          */}
        {
          type === InquiryTypes.REALISATION
          ? (
            <div>
              <label
                style={{fontWeight: 600}}
                className={!this.store.pristine && !this.checkDurationValidity() ? 'form__label form__label--error' : 'form__label'}
                htmlFor='dispo'>{t('common:fields:visits_duration')}
              </label>
              <div className='demande-form__select'>
                <Input label='' type='number' value={stores.inquiry.duration.hours} onChange={(value) => { stores.inquiry.duration.hours = value }} name='hours' />
              </div>
              <span className=''>h</span>
              <SelectNumberGroup selectedValue={stores.inquiry.duration.minutes} onChange={(value) => { stores.inquiry.duration.minutes = value }} name='minutes'>
                <Select value='0'>0</Select>
                <Select value='15'>15</Select>
                <Select value='30'>30</Select>
                <Select value='45'>45</Select>
              </SelectNumberGroup>
              <span>min</span>
            </div>
          ) : ''
        }
        { !this.store.pristine && !this.store.isValid
          ? (
            <div className='form__errormessage' style={{ textAlign: 'center', marginBottom: '10px' }}>
              <b>{ t('common:demande:errors:invalid_form') }</b>
              {errors ? errors.map((e, i) => <div key={i} style={{ }}>{e}</div>) : ''}
            </div>
          ) : ''
        }
        <div className='form__submit'>
          <NavigationButtons next={() => this.handleSubmit()} />
        </div>
      </div>
    )
  }
}

NeedsStepComponent.propTypes = {
  t: func,
  next: func
}

export const NeedsStepV1 = translate()(view(NeedsStepComponent))



// WEBPACK FOOTER //
// ./src/components/inquiry/v1/NeedsStepV1.js